import api from './api';

export const contractService = {
  async getAll() {
    const response = await api.get('/contracts');
    return response.data;
  },

  async getById(id) {
    const response = await api.get(`/contracts/${id}`);
    return response.data;
  },

  async getByNumber(number) {
    const response = await api.get(`/contracts/by-number/${number}`);
    return response.data;
  },

  async create(contractData) {
    const response = await api.post('/contracts', contractData);
    return response.data;
  },

  async createBulk(bulkData) {
    const response = await api.post('/contracts/bulk', bulkData);
    return response.data;
  },

  async update(id, contractData) {
    const response = await api.put(`/contracts/${id}`, contractData);
    return response.data;
  },

  async delete(id) {
    await api.delete(`/contracts/${id}`);
  },

  async generatePdf(id) {
    const response = await api.post(`/contracts/${id}/generate-pdf`);
    return response.data;
  },

  async downloadPdf(id) {
    console.log(id);
    const response = await api.get(`/contracts/${id}/download-pdf`, {
      responseType: 'blob',
    });

    // --- 1. Extract the Filename from Headers ---
    const contentDisposition = response.headers['content-disposition'];
    let filename = `contract_${id}.pdf`; // Fallback filename

    if (contentDisposition) {
      // This regex extracts the quoted filename from the Content-Disposition header
      const filenameMatch = contentDisposition.match(/filename\*?=['"]?([^"']+)['"]?(?:$|;)/i);
      if (filenameMatch && filenameMatch[1]) {
        // Decode the filename (important for non-ASCII characters) and clean up quotes
        filename = decodeURIComponent(filenameMatch[1].replace(/['"]/g, ''));
      }
    }

    // --- 2. Return the data and the filename ---
    return {
      blob: response.data,
      filename: filename,
    };
  },

  async sendContract(id, emails) {
    const response = await api.post(`/contracts/${id}/send`, { emails });
    return response.data;
  },

  async getAccessLink(id) {
    const response = await api.post(`/contracts/${id}/access-link`);
    return response.data;
  },

  async uploadSignedDocument(id, file) {
    const formData = new FormData();
    formData.append('file', file);

    const response = await api.post(`/contracts/${id}/upload-signed`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  async getExpiringContracts(days = 30) {
    const response = await api.get(`/contracts/expiring?days=${days}`);
    return response.data;
  },

  async getByClient(clientId) {
    const response = await api.get(`/contracts/by-client/${clientId}`);
    return response.data;
  },

  async search(searchTerm) {
    const response = await api.get(`/contracts/search?searchTerm=${encodeURIComponent(searchTerm)}`);
    return response.data;
  },

  async getBulkDownload(year) {
    const response = await api.get(`/contracts/bulk-download/${year}`, {
      responseType: 'blob',
    });
    return response.data;
  },

  async updateContent(id, content) {
    const response = await api.put(`/contracts/${id}/content`, content, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  },

  async terminate(id) {
    const response = await api.post(`/contracts/${id}/terminate`);
    return response.data;
  },

  async exportToExcel() {
    const response = await api.get('/contracts/export', {
      responseType: 'blob',
    });
    return response.data;
  },

  // Additional methods that might be useful
  async getContractsByStatus(status) {
    const response = await api.get(`/contracts/by-status/${status}`);
    return response.data;
  },

  async getContractStatistics() {
    const response = await api.get('/contracts/statistics');
    return response.data;
  },

  async getRecentContracts(limit = 10) {
    const response = await api.get(`/contracts/recent?limit=${limit}`);
    return response.data;
  },

  async signContract(id, signatureData) {
    const response = await api.post(`/contracts/${id}/sign`, signatureData);
    return response.data;
  },

  async approveContract(id) {
    const response = await api.post(`/contracts/${id}/approve`);
    return response.data;
  },

  async rejectContract(id, reason) {
    const response = await api.post(`/contracts/${id}/reject`, { reason });
    return response.data;
  },

  async duplicateContract(id) {
    const response = await api.post(`/contracts/${id}/duplicate`);
    return response.data;
  },

  async getContractHistory(id) {
    const response = await api.get(`/contracts/${id}/history`);
    return response.data;
  },

  async addNote(id, note) {
    const response = await api.post(`/contracts/${id}/notes`, { note });
    return response.data;
  },

  async getNotes(id) {
    const response = await api.get(`/contracts/${id}/notes`);
    return response.data;
  },

  async generateRenewalContract(id, renewalData) {
    const response = await api.post(`/contracts/${id}/renew`, renewalData);
    return response.data;
  },

  async getContractsByClient(clientId) {
    const response = await api.get(`/contracts/by-client/${clientId}`);
    return response.data;
  },

  // Batch operations
  async batchUpdateStatus(contractIds, status) {
    const response = await api.put('/contracts/batch/status', {
      contractIds,
      status
    });
    return response.data;
  },

  async batchDelete(contractIds) {
    const response = await api.delete('/contracts/batch', {
      data: { contractIds }
    });
    return response.data;
  },

  async batchSend(contractIds, emails) {
    const response = await api.post('/contracts/batch/send', {
      contractIds,
      emails
    });
    return response.data;
  },

  async downloadSignedFile(id, path) {
    const response = await api.get(`/contracts/${id}/download-signed-file`, {
      params: { path },
      responseType: 'blob'
    });
    return response.data;
  },
};